import axios from 'axios';
import { getAuthHeader } from '../auth/authService';
import { API_BASE_URL } from '../../config/api';

const locationService = {
  // Countries
  getAllCountries: async () => {
    const response = await axios.get(`${API_BASE_URL}/locations/countries`, {
      headers: getAuthHeader(),
    });
    return response.data;
  },

  getCountryById: async (id) => {
    const response = await axios.get(`${API_BASE_URL}/locations/countries/${id}`, {
      headers: getAuthHeader(),
    });
    return response.data;
  },

  createCountry: async (countryData) => {
    const response = await axios.post(
      `${API_BASE_URL}/locations/countries`,
      countryData,
      { headers: getAuthHeader() }
    );
    return response.data;
  },

  updateCountry: async (id, countryData) => {
    const response = await axios.put(
      `${API_BASE_URL}/locations/countries/${id}`,
      countryData,
      { headers: getAuthHeader() }
    );
    return response.data;
  },

  deleteCountry: async (id) => {
    const response = await axios.delete(
      `${API_BASE_URL}/locations/countries/${id}`,
      { headers: getAuthHeader() }
    );
    return response.data;
  },

  // Cities
  getAllCities: async (countryId = null) => {
    const url = countryId
      ? `${API_BASE_URL}/locations/countries/${countryId}/cities`
      : `${API_BASE_URL}/locations/cities`;
    const response = await axios.get(url, {
      headers: getAuthHeader(),
    });
    return response.data;
  },

  getCityById: async (id) => {
    const response = await axios.get(`${API_BASE_URL}/locations/cities/${id}`, {
      headers: getAuthHeader(),
    });
    return response.data;
  },

  createCity: async (cityData) => {
    const response = await axios.post(
      `${API_BASE_URL}/locations/cities`,
      cityData,
      { headers: getAuthHeader() }
    );
    return response.data;
  },

  updateCity: async (id, cityData) => {
    const response = await axios.put(
      `${API_BASE_URL}/locations/cities/${id}`,
      cityData,
      { headers: getAuthHeader() }
    );
    return response.data;
  },

  deleteCity: async (id) => {
    const response = await axios.delete(
      `${API_BASE_URL}/locations/cities/${id}`,
      { headers: getAuthHeader() }
    );
    return response.data;
  },

  // Areas
  getAreasByCity: async (cityId) => {
    const response = await axios.get(`${API_BASE_URL}/locations/areas`, {
      params: { cityId },
      headers: getAuthHeader(),
    });
    return response.data;
  },

  getAreaById: async (id) => {
    const response = await axios.get(`${API_BASE_URL}/locations/areas/${id}`, {
      headers: getAuthHeader(),
    });
    return response.data;
  },

  createArea: async (areaData) => {
    const response = await axios.post(
      `${API_BASE_URL}/locations/areas`,
      areaData,
      { headers: getAuthHeader() }
    );
    return response.data;
  },

  updateArea: async (id, areaData) => {
    const response = await axios.put(
      `${API_BASE_URL}/locations/areas/${id}`,
      areaData,
      { headers: getAuthHeader() }
    );
    return response.data;
  },

  deleteArea: async (id) => {
    const response = await axios.delete(
      `${API_BASE_URL}/locations/areas/${id}`,
      { headers: getAuthHeader() }
    );
    return response.data;
  },
};

export default locationService;

